import { RightshipEexiComplianceTypeEnum } from './../../../models/vessels/vessel.models';
import { autoinject, computedFrom, bindable } from "aurelia-framework";

@autoinject
export class CompBannerEexi {
   
    eexiWarningDeadline: Date = new Date(2023, 0, 1);

    today: Date;

    @bindable
    isCondensed: boolean = false;
    
    @bindable
    showTooltip: boolean = true;

    @bindable
    isEexiCompliant: boolean;

    @bindable
    isEexiApplicable: boolean;

    @bindable
    eexiComplianceType: RightshipEexiComplianceTypeEnum;

    public title: string = "EEXI NOT UPDATED";

    public message: string = "Request environmental review";

    @computedFrom('eexiWarningDeadline', 'today')
    get exceedsDeadline(): boolean {
        return this.today >= this.eexiWarningDeadline;
    }
    
    constructor() {
        this.today = new Date();
        this.today.setHours(0,0,0,0);
    }
}
